import store from '@/store'

function isHalfTemplate () {
  var screenConfiguration = store.getters['cduState/getScreenConfiguration']

  return screenConfiguration.is2showeventsin2columns &&
        (screenConfiguration.is2showoutrightevents || screenConfiguration.is2showsingleevent)
}

function determineScreenState () {
  let screenConfiguration = store.getters['cduState/getScreenConfiguration']
  let result = 'default'
  let states = []
  let state = ''

  if (screenConfiguration.is2showeventsin2columns) states.push('2column')
  if (screenConfiguration.is2showsingleevent) states.push('single')
  if (screenConfiguration.is2showoutrightevents) states.push('outright')
  if (screenConfiguration.is2showstats) states.push('stats')

  if (states.length > 0) {
    state = states.join('-')
  }

  if (screenConfiguration.topmarketinglinetext.indexOf('http://') > -1 || screenConfiguration.topmarketinglinetext.indexOf('https://') > -1) {
    state = 'banner'
  }

  if (state) {
    result = state
  }

  store.commit('cduState/setScreenState', result)
}

export default {
  isHalfTemplate,
  determineScreenState
}



// WEBPACK FOOTER //
// ./src/library/cdu/config.js